document.addEventListener('DOMContentLoaded', (event) => {
  const accordions = document.querySelectorAll('.accordion');
  if (accordions) {
    accordions.forEach((accordion) => {
      const header = accordion.querySelector('.accordion-head');
      const content = accordion.querySelector('.accordion__content');

      header.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('active');

        // Close all accordions
        accordions.forEach((item) => {
          item.classList.remove('active');
          const innerContent = item.querySelector('.accordion__content');
          innerContent.style.maxHeight = null;
          innerContent.style.padding = '0 0';
          innerContent.style.marginBottom = '0px';
        });

        // If it wasn't already open, open this one
        if (!isOpen) {
          accordion.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.marginBottom = '20px'; // Adjust as needed
        }
      });
    });
  }
});
